import axios from "axios"
import baseUrl from "./base"

const permohonanApi = {
  fetchPermohonanPenduduk: async (token) => {
    return await axios.get(`${baseUrl}/api/dataPermohonanPenduduk/get`,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  fetchPaginatePermohonanPenduduk: async (token, data) => {
    return await axios.get(`${baseUrl}/api/dataPermohonanPenduduk/paginate`,
      { params: data, headers: { Authorization: `Bearer ${token}` } }
    )
  },
  getAllStatusPermohonanPenduduk: async (token, data) => {
    return await axios.get(`${baseUrl}/api/dataPermohonanPenduduk/getAllStatusPermohonan`,
      { params: data, headers: { Authorization: `Bearer ${token}` } }
    )
  },
  fetchPermohonanDesa: async (token) => {
    return await axios.get(`${baseUrl}/api/dataPermohonanOperator/getDesa`,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  fetchPaginatePermohonanDesa: async (token, data) => {
    return await axios.get(`${baseUrl}/api/dataPermohonanOperator/paginateDesa`,
      { params: data, headers: { Authorization: `Bearer ${token}` } }
    )
  },
  fetchPaginatePermohonanRumahSakit: async (token, data) => {
    return await axios.get(`${baseUrl}/api/dataPermohonanOperator/paginateRumahSakit`,
      { params: data, headers: { Authorization: `Bearer ${token}` } }
    )
  },
  getAllStatusPermohonanDesa: async (token, data) => {
    return await axios.get(`${baseUrl}/api/dataPermohonanOperator/getAllStatusPermohonanDesa`,
      { params: data, headers: { Authorization: `Bearer ${token}` } }
    )
  },
  getAllStatusPermohonanDesaRiwayatInput: async (token, data) => {
    return await axios.get(`${baseUrl}/api/dataPermohonanOperator/getAllStatusPermohonanDesaRiwayatInput`,
      { params: data, headers: { Authorization: `Bearer ${token}` } }
    )
  },
  getAllStatusPermohonanRumahSakit: async (token, data) => {
    return await axios.get(`${baseUrl}/api/dataPermohonanOperator/getAllStatusPermohonanRumahSakit`,
      { params: data, headers: { Authorization: `Bearer ${token}` } }
    )
  },
  getAllStatusPermohonanRumahSakitRiwayatInput: async (token, data) => {
    return await axios.get(`${baseUrl}/api/dataPermohonanOperator/getAllStatusPermohonanRumahSakitRiwayatInput`,
      { params: data, headers: { Authorization: `Bearer ${token}` } }
    )
  },
  fetchRiwayatInputDesa: async (token, data) => {
    return await axios.get(`${baseUrl}/api/dataPermohonanOperator/getDesa/riwayatInputDesa`,
      { params: data, headers: { Authorization: `Bearer ${token}` } }
    )
  },
  fetchRiwayatInputRumahSakit: async (token, data) => {
    return await axios.get(`${baseUrl}/api/dataPermohonanOperator/getRs/riwayatInputRumahSakit`,
      { params: data, headers: { Authorization: `Bearer ${token}` } }
    )
  },
  fetchPermohonanKecamatan: async (token) => {
    return await axios.get(`${baseUrl}/api/dataPermohonanOperator/getKecamatan`,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  fetchPaginatePermohonanKecamatan: async (token, data) => {
    return await axios.get(`${baseUrl}/api/dataPermohonanOperator/paginateKecamatan`,
      { params: data, headers: { Authorization: `Bearer ${token}` } }
    )
  },
  getAllStatusPermohonanKecamatan: async (token, data) => {
    return await axios.get(`${baseUrl}/api/dataPermohonanOperator/getAllStatusPermohonanKecamatan`,
      { params: data, headers: { Authorization: `Bearer ${token}` } }
    )
  },
  fetchPermohonanDukcapil: async (token) => {
    return await axios.get(`${baseUrl}/api/dataPermohonanOperator/getDukcapil`,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  fetchPaginatePermohonanDukcapil: async (token, data) => {
    return await axios.get(`${baseUrl}/api/dataPermohonanOperator/paginateDukcapil`,
      { params: data, headers: { Authorization: `Bearer ${token}` } }
    )
  },
  getAllStatusPermohonanDukcapil: async (token, data) => {
    return await axios.get(`${baseUrl}/api/dataPermohonanOperator/getAllStatusPermohonanDukcapil`,
      { params: data, headers: { Authorization: `Bearer ${token}` } }
    )
  },
  // fetchPermohonanDesaByPenduduk: async(token) => { // where desa where id penduduk
  //     return await axios.get( `${baseUrl}/api/dataPermohonanOperator/getDesa`,
  //         { headers: { Authorization: `Bearer ${token}` } }
  //     )
  // },
  storePermohonanPenduduk: async (token, data) => {
    return await axios.post(`${baseUrl}/api/dataPermohonanPenduduk/store`, data,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  storePermohonanPendudukByDesa: async (token, data) => {
    return await axios.post(`${baseUrl}/api/dataPermohonanOperator/storeDesa`, data,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  storePermohonanPendudukByRumahSakit: async (token, data) => {
    return await axios.post(`${baseUrl}/api/dataPermohonanOperator/storeRs`, data,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  showDataPermohonanPenduduk: async (token, id) => {
    return await axios.get(`${baseUrl}/api/dataPermohonanPenduduk/${id}/show?hideId=1`,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  showDataPermohonanPendudukByDesa: async (token, id) => {
    return await axios.get(`${baseUrl}/api/dataPermohonanPenduduk/${id}/show?showByDesa=1&hideId=1`,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  showDataPermohonanPendudukByRumahSakit: async (token, id) => {
    return await axios.get(`${baseUrl}/api/dataPermohonanPenduduk/${id}/show?showByRs=1&hideId=1`,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  showDataPermohonanPendudukByKecamatan: async (token, id) => {
    return await axios.get(`${baseUrl}/api/dataPermohonanPenduduk/${id}/show?showByKecamatan=1&hideId=1`,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  showDataPermohonanPendudukByDukcapil: async (token, id) => {
    return await axios.get(`${baseUrl}/api/dataPermohonanPenduduk/${id}/show?showByDukcapil=1&hideId=1`,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  showRiwayatDataPermohonan: async (token, id) => {
    return await axios.get(`${baseUrl}/api/dataPermohonanPenduduk/${id}/riwayat`,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  hapusPermohonanPenduduk: async (token, id) => {
    return await axios.delete(`${baseUrl}/api/dataPermohonanPenduduk/${id}/destroy`,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  hapusPermohonanPendudukByDesa: async (token, id) => {
    return await axios.delete(`${baseUrl}/api/dataPermohonanOperator/${id}/destroyByDesa`,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  hapusPermohonanPendudukByAdmin: async (token, id) => {
    return await axios.delete(`${baseUrl}/api/dataPermohonanOperator/${id}/destroyByAdmin`,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  batalkanPermohonanPenduduk: async (token, id) => {
    return await axios.delete(`${baseUrl}/api/dataPermohonanPenduduk/${id}/cancel`,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  batalkanPermohonanPendudukByDesa: async (token, id) => {
    return await axios.delete(`${baseUrl}/api/dataPermohonanOperator/${id}/cancelByDesa`,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  updatePermohonanPenduduk: async (token, id, data) => {
    return await axios.post(`${baseUrl}/api/dataPermohonanPenduduk/${id}/update`, data,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  fetchFileDataPermohonan: async (token, id) => {
    return await axios.get(`${baseUrl}/api/fileDataPermohonanPenduduk/get?id_data_permohonan=${id}`,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  fetchFilePermohonanByRs: async (token, id) => {
    return await axios.get(`${baseUrl}/api/filePermohonanOperator/getRs?id_data_permohonan=${id}`,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  fetchFilePermohonanByDesa: async (token, id) => {
    return await axios.get(`${baseUrl}/api/filePermohonanOperator/getDesa?id_data_permohonan=${id}`,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  fetchFilePermohonanByKecamatan: async (token, id) => {
    return await axios.get(`${baseUrl}/api/filePermohonanOperator/getKecamatan?id_data_permohonan=${id}`,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  fetchFilePermohonanByDukcapil: async (token, id) => {
    return await axios.get(`${baseUrl}/api/filePermohonanOperator/getDukcapil?id_data_permohonan=${id}`,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  uploadSuratPengantar: async (token, id, data) => {
    return await axios.post(`${baseUrl}/api/dataPermohonanPenduduk/${id}/uploadSuratPengantar`, data,
      { headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" } }
    )
  },
  uploadBerkasPermohonan: async (token, data) => {
    return await axios.post(`${baseUrl}/api/fileDataPermohonanPenduduk/store`, data,
      { headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" } }
    )
  },
  updateBerkasPermohonan: async (token, id, data) => {
    return await axios.post(`${baseUrl}/api/fileDataPermohonanPenduduk/${id}/update`, data,
      { headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" } }
    )
  },
  hapusBerkasPermohonan: async (token, id) => {
    return await axios.delete(`${baseUrl}/api/fileDataPermohonanPenduduk/${id}/destroy`,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  validasiPermohonanByDesa: async (token, id, data) => {
    return await axios.post(`${baseUrl}/api/dataPermohonanOperator/${id}/validDesa`, data,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  validasiFilePermohonanByRs: async (token, id, data) => {
    return await axios.post(`${baseUrl}/api/dataPermohonanOperator/${id}/validRs`, data,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  validasiPermohonanByKecamatan: async (token, id, data) => {
    return await axios.post(`${baseUrl}/api/dataPermohonanOperator/${id}/validKecamatan`, data,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  validasiPermohonanByDukcapil: async (token, id, data) => {
    return await axios.post(`${baseUrl}/api/dataPermohonanOperator/${id}/validDukcapil`, data,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  validasiFilePermohonanByDesa: async (token, id, data) => {
    return await axios.post(`${baseUrl}/api/filePermohonanOperator/${id}/validDesa`, data,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  validasiFilePermohonanByKecamatan: async (token, id, data) => {
    return await axios.post(`${baseUrl}/api/filePermohonanOperator/${id}/validKecamatan`, data,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  validasiFilePermohonanByDukcapil: async (token, id, data) => {
    return await axios.post(`${baseUrl}/api/filePermohonanOperator/${id}/validDukcapil`, data,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  fetchHasilPermohonan: async (token, id) => {
    return await axios.get(`${baseUrl}/api/hasilPermohonanPenduduk/get?id_data_permohonan=${id}`,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  fetchHasilPermohonanByOperator: async (token, id) => {
    return await axios.get(`${baseUrl}/api/hasilPermohonanOperator/get?id_data_permohonan=${id}`,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  storeHasilPermohonanByOperator: async (token, data) => {
    return await axios.post(`${baseUrl}/api/hasilPermohonanOperator/store`, data,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  updateHasilPermohonanByOperator: async (token, id, data) => { // id = id_hasil_permohonan
    return await axios.post(`${baseUrl}/api/hasilPermohonanOperator/${id}/update`, data,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  deleteHasilPermohonanByOperator: async (token, id) => { // id = id_hasil_permohonan
    return await axios.delete(`${baseUrl}/api/hasilPermohonanOperator/${id}/destroy`,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  },
  setBerkasTambahan: async (token, data) => {
    return await axios.post(`${baseUrl}/api/filePermohonanOperator/setBerkasTambahan`, data,
      { headers: { Authorization: `Bearer ${token}` } }
    )
  }
}

export default permohonanApi